import {gql} from "@apollo/client";

import {MonitoringServiceType, ServiceDefinition, ServiceGroup} from "@/lib/types/checks.ts";

export interface CheckUsage {
  checkType: MonitoringServiceType;
  used: number;
}

export interface LaunchpadContentResponse {
  monitoringServiceTypes: ServiceGroup[];
  serviceDefinitions: ServiceDefinition[];
  checksUsage: CheckUsage[];
  firstDashboardID: number;
  user: {
    id: number;
    account: {
      id: number;
      enable_statuspages: boolean;
    };
  };
}

export const GQL_LAUNCHPAD_CONTENT = gql`
  query LaunchpadContent {
    monitoringServiceTypes {
      ...MonitoringGroupFields
    }
    serviceDefinitions {
      service_type
      verbose_name
      help_text
      support_link
    }
    checksUsage {
      checkType
      used
    }
    user: currentUser {
      id
      account {
        id
        enable_statuspages
      }
    }
    firstDashboardID
  }
`;

export const GQL_LAUNCHPAD_BAR = gql`
  query Launchpad {
    settingsInfo {
      free_trial_period
    }
  }
`;
